import styled from 'styled-components';

const Heading1 = styled.h1`
  text-align: center;
  margin-bottom: 16px;
`;

export default Heading1;
